import { CSSTransition } from 'react-transition-group'
import styled from 'styled-components'

export const StyledCSSTransition = styled(CSSTransition)`
  position: absolute;
  width: 100vw;
  height: 100vh;
  transition: opacity ${({ timeout }) => timeout}ms ease-in-out;

  // Transition animations

  /* starting ENTER animation */
  &.content-transition-enter {
    opacity: 0;
  }

  /* ending ENTER animation */
  &.content-transition-enter-active {
    opacity: 1;
  }

  /* starting EXIT animation */
  &.content-transition-exit {
    opacity: 1;
  }

  /* ending EXIT animation */
  &.content-transition-exit-active {
    opacity: 0;
  }
`
